import React, { useEffect, useState } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const {
    scrollY
  } = useScroll();
  // Update scrolled state based on scroll position
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <motion.nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ease-out border-b ${isScrolled ? 'bg-cream/90 backdrop-blur-md border-stone/50 py-4' : 'bg-transparent border-transparent py-6'}`} initial={{
    y: -100,
    opacity: 0
  }} animate={{
    y: 0,
    opacity: 1
  }} transition={{
    duration: 0.8,
    ease: 'easeOut'
  }} data-id="element-57">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-58">
        {/* Logo */}
        <div className="flex-shrink-0" data-id="element-59">
          <a href="#" className="font-serif text-2xl text-charcoal tracking-wide" data-id="element-60">
            Yearn
          </a>
        </div>

        {/* Desktop Links */}
        <div className="hidden md:flex items-center space-x-8" data-id="element-61">
          {['Home', 'About', 'How It Works', 'Gift'].map(item => <a key={item} href={`#${item.toLowerCase().replace(/\s+/g, '-')}`} className="text-xs uppercase tracking-widest text-warm-gray hover:text-charcoal transition-colors duration-300 font-medium" data-id="element-62">
              {item}
            </a>)}
        </div>

        {/* Right Actions */}
        <div className="flex items-center space-x-6" data-id="element-63">
          <a href="#login" className="hidden md:block text-sm text-charcoal hover:text-warm-gray transition-colors font-medium" data-id="element-64">
            Log In
          </a>
          <a href="#subscribe" className={`px-5 py-2 rounded-full text-sm font-medium transition-all duration-300 ${isScrolled ? 'bg-charcoal text-cream hover:bg-warm-gray' : 'bg-charcoal text-cream hover:bg-warm-gray shadow-lg shadow-charcoal/10'}`} data-id="element-65">
            Subscribe
          </a>
        </div>
      </div>
    </motion.nav>;
}